import React from 'react'
import type { UserMembership } from '../../types/membership'
import type { MembershipThresholds } from '../../services/membershipService'
import { MembershipBadge } from './MembershipBadge'
import { MembershipProgress } from './MembershipProgress'

interface MembershipCardProps {
  membership: UserMembership
  thresholds?: MembershipThresholds | null
}

export const MembershipCard: React.FC<MembershipCardProps> = ({ membership, thresholds }) => {
  const formatDate = (dateStr?: string) => {
    if (!dateStr) return '-'
    return new Date(dateStr).toLocaleDateString('id-ID', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })
  }

  return (
    <div className="bg-white dark:bg-slate-900 rounded-[2.5rem] border border-slate-100 dark:border-white/5 p-10 shadow-[0_20px_50px_rgba(0,0,0,0.02)]">
      <div className="flex items-center gap-4 mb-8 pb-8 border-b border-slate-50 dark:border-white/5">
        <div className="size-12 bg-amber-500/10 rounded-2xl flex items-center justify-center">
          <span className="material-symbols-outlined text-amber-500 text-[24px]">emoji_events</span>
        </div>
        <div>
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white leading-none">Membership</h2>
          <p className="text-sm text-slate-400 font-medium mt-1">Status keanggotaan Anda</p>
        </div>
      </div>

      <div className="space-y-6">
        <div className="flex items-center gap-4">
          <MembershipBadge tier={membership.tier} size="lg" />
          <div className="flex-1">
            <div className="grid grid-cols-2 gap-4">
              <div className="p-4 bg-slate-50 dark:bg-white/5 rounded-2xl">
                <p className="text-xs font-bold text-slate-400 dark:text-slate-500 mb-1">Total Hadir</p>
                <p className="text-2xl font-black text-slate-900 dark:text-white">{membership.totalAttendance}</p>
              </div>
              <div className="p-4 bg-slate-50 dark:bg-white/5 rounded-2xl">
                <p className="text-xs font-bold text-slate-400 dark:text-slate-500 mb-1">Hadir Tahun Ini</p>
                <p className="text-2xl font-black text-slate-900 dark:text-white">{membership.yearAttendance}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-xs text-slate-400 dark:text-slate-500">
          <span className="font-bold">Diperoleh:</span> {formatDate(membership.earnedAt)}
        </div>

        <MembershipProgress membership={membership} thresholds={thresholds} />
      </div>
    </div>
  )
}
